import { useRef } from "react";
import Render from "../pages/canvas/paper/render";
import DND from "../pages/canvas/paper/dndhandler";

export default function List(props) {
  const ref = useRef(null);

  return (
    <div
      ref={props.editorRef}
      style={{
        flexGrow: props.block.props.flexGrow,
        visibility: props.block.hidden ? "hidden" : "unset",
        backgroundColor: props.block.props.backgroundColor,

        ...props.block.props.size,
        overflowY: "scroll",
        position: "relative",
      }}
    >
      {props.children.map((block, index) => {
        const newPath = [...props.path];
        newPath.push(index);

        return (
          <DND
            key={block.id}
            disabled={props.disabled}
            index={index}
            path={newPath}
            block={block}
          >
            <Render />
          </DND>
        );
      })}
    </div>
  );
}
